import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { submitContact } from "@/lib/api";

const services = [
  "Dog Training — Private", "Dog Training — Boot Camp", "Puppy Camp", "Behavioral Rehab", "Service Dog Training", "Train-the-Trainer",
  "Business Consulting", "Brand Strategy", "AI Coaching / Super Session", "Speaking Engagement",
  "Golden Wolf Foundation (nonprofit)", "Media / Press",
  "Book — Consciousness of Abundance", "Other",
];
const budgets = ["Under $500", "$500 – $2,500", "$2,500 – $10,000", "$10,000 – $50,000", "$50,000+", "Prefer to discuss"];

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", service: services[0], budget: "", message: "" });
  const [loading, setLoading] = useState(false);
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  useEffect(() => { document.title = "Contact — Toriano Sanzone"; window.scrollTo(0, 0); }, []);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await submitContact(form);
      toast.success("Thank you. Your inquiry has been received. Toriano's team will review your request and contact qualified applicants.");
      setForm({ name: "", phone: "", email: "", service: services[0], budget: "", message: "" });
    } catch { toast.error("Something went wrong. Please call 312-933-1528."); }
    finally { setLoading(false); }
  };

  return (
    <div className="pt-[120px] md:pt-[140px]" data-testid="contact-page">
      <section className="max-w-[1600px] mx-auto px-6 md:px-10 pb-16">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="text-eyebrow text-gold">Contact</div>
            <h1 className="font-display text-[clamp(2.4rem,7vw,7rem)] leading-[0.92] tracking-[-0.03em] mt-4">
              Let&apos;s <span className="italic gold-foil">talk.</span>
            </h1>
            <p className="mt-6 text-bone/70 font-editorial text-lg max-w-md">Every serious inquiry receives a hand-drafted response within 24 hours. For urgent dog-training needs, call or text.</p>

            <div className="mt-12 space-y-6">
              <div>
                <div className="text-hair text-bone/50 mb-1">Call or text</div>
                <a href="tel:3129331528" className="font-display text-3xl md:text-4xl italic text-bone hover:text-gold transition-colors" data-testid="contact-phone">312.933.1528</a>
              </div>
              <div className="flex gap-3">
                <a href="tel:3129331528" className="btn-gold" data-testid="contact-call">Call</a>
                <a href="sms:3129331528" className="btn-outline" data-testid="contact-text">Text</a>
              </div>
              <div>
                <div className="text-hair text-bone/50 mb-1">Studio</div>
                <div className="text-bone/85">Chicago, Illinois</div>
              </div>
            </div>
          </div>

          <motion.form
            initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
            onSubmit={submit} className="md:col-span-7 grid md:grid-cols-2 gap-6" data-testid="contact-form"
          >
            <div className="field"><label>Name</label><input required value={form.name} onChange={upd("name")} data-testid="contact-name"/></div>
            <div className="field"><label>Phone</label><input required value={form.phone} onChange={upd("phone")} data-testid="contact-phone-input"/></div>
            <div className="field md:col-span-2"><label>Email</label><input required type="email" value={form.email} onChange={upd("email")} data-testid="contact-email"/></div>
            <div className="field"><label>Type of inquiry</label>
              <select value={form.service} onChange={upd("service")} data-testid="contact-service">
                {services.map(s => <option key={s}>{s}</option>)}
              </select>
            </div>
            <div className="field"><label>Budget</label>
              <select value={form.budget} onChange={upd("budget")} data-testid="contact-budget">
                <option value="">Select</option>
                {budgets.map(b => <option key={b}>{b}</option>)}
              </select>
            </div>
            <div className="field md:col-span-2"><label>Message</label><textarea value={form.message} onChange={upd("message")} data-testid="contact-message" placeholder="Tell us what you're building." /></div>
            <div className="md:col-span-2 pt-2">
              <button type="submit" disabled={loading} className="btn-gold" data-testid="contact-submit">
                {loading ? "Sending…" : "Send Inquiry"}
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M13 5l7 7-7 7"/></svg>
              </button>
            </div>
          </motion.form>
        </div>
      </section>
    </div>
  );
}
